export default "__VITE_ASSET__yi_9JTUI__"